import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AWNLogo from '../components/AWNLogo';
import { logoutUser, verifyEmailToken } from '../services/authService';
import styles from '../style/ForgotPasswordPage.module.css';

function getSignupToken() {
  if (typeof window === 'undefined') return null;
  const query = new URLSearchParams(window.location.search);
  const tokenHash = query.get('token_hash');
  if (!tokenHash) return null;
  return { tokenHash, type: query.get('type') || 'email' };
}

function ConfirmSignupPage() {
  const [state, setState] = useState('checking');
  const [message, setMessage] = useState('Einen Moment bitte.');

  useEffect(() => {
    let active = true;
    const token = getSignupToken();

    if (!token) {
      setState('invalid');
      setMessage('Dieser Bestätigungs-Link ist unvollständig oder nicht mehr gültig.');
      return () => { active = false; };
    }

    if (token.type !== 'email') {
      setState('invalid');
      setMessage('Dieser Link gehört nicht zu einer E-Mail-Bestätigung.');
      return () => { active = false; };
    }

    verifyEmailToken(token.tokenHash, token.type)
      .then(async () => {
        // Verification should not silently log the user in on a shared device.
        // The account is confirmed; the user can now sign in normally.
        try { await logoutUser(); } catch (_error) { /* verification succeeded */ }
        if (active) setState('success');
      })
      .catch((error) => {
        if (!active) return;
        setState('invalid');
        setMessage(error?.message || 'Dieser Bestätigungs-Link ist ungültig oder abgelaufen.');
      });

    return () => { active = false; };
  }, []);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.backgroundPattern} aria-hidden="true" />
      <div className={styles.splitContainer}>
        <aside className={styles.socialColumn}>
          <div className={styles.socialLogoSection}>
            <AWNLogo width={300} height={100} className={styles.companyLogo} />
          </div>
          <p className={styles.sideCopy}>Bestätigen Sie Ihre E-Mail-Adresse, um AWN sicher zu nutzen.</p>
        </aside>

        <section className={styles.forgotCard}>
          {state === 'checking' && (
            <div className={styles.outcomePanel} role="status">
              <div className={styles.outcomeIcon} aria-hidden="true">…</div>
              <p className={styles.eyebrow}>E-Mail wird bestätigt</p>
              <h1 className={styles.forgotTitle}>Link wird geprüft</h1>
              <p className={styles.forgotSubtitle}>{message}</p>
            </div>
          )}

          {state === 'success' && (
            <div className={styles.outcomePanel} role="status">
              <div className={styles.outcomeIcon} aria-hidden="true">✓</div>
              <p className={styles.eyebrow}>E-Mail bestätigt</p>
              <h1 className={styles.forgotTitle}>Ihr Konto ist bereit</h1>
              <p className={styles.forgotSubtitle}>Ihre E-Mail-Adresse wurde bestätigt. Sie können sich jetzt anmelden.</p>
              <Link to="/login" className={styles.primaryLink}>Jetzt anmelden</Link>
            </div>
          )}

          {state === 'invalid' && (
            <div className={styles.outcomePanel} role="alert">
              <div className={styles.outcomeIcon} aria-hidden="true">!</div>
              <p className={styles.eyebrow}>Link nicht verfügbar</p>
              <h1 className={styles.forgotTitle}>Bestätigung nicht möglich</h1>
              <p className={styles.forgotSubtitle}>{message}</p>
              <p className={styles.forgotSubtitle}>Fordern Sie auf der Anmeldeseite eine neue Bestätigungs-E-Mail an.</p>
              <Link to="/login" className={styles.primaryLink}>Zur Anmeldung</Link>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

export default ConfirmSignupPage;
